export namespace CypressTestNamespace {
  export enum ELayoutElements {
    STEP_CHAIN_WRAPPER = 'stepChain',
  }

  export enum ECartPageButtons {
    BACK_TO_STORE_BUTTON = 'backToStore',
    TO_CHECKOUT_BUTTON = 'toCashRegister',
    BACK_TO_PREVIOUS_PAGE = 'backToPreviousPage',
    PROCEED_TO_ORDER_BUTTON = 'proceeedToOrder',
  }

  export enum ECartPageServices {
    ECO_PACKAGING_SERVICE = 'ecoWrapping',
    INSURANCE_SERVICE = 'insurePackage',
    FUND_RAISING = 'fundRaising',
    GIFT_PACKAGING_SERVICE = 'giftWrapping',
    GIFT_PACKAGING_SERVICE_QUANTITY = 'giftPackagingQuantity',
    GIFT_PACKAGING_SERVICE_ITEM_PRICE = 'giftPackagingItemPrice',
    GIFT_PACKAGING_SERVICE_TOTAL_PRICE = 'giftPackagingTotalPrice',
    GIFT_PACKAGING_SERVICE_UNAVAILABLE = 'giftPackagingUnavailable',
  }

  export enum ECartPageDiscoveryBox {
    DISCOVERY_BOX_MODAL = 'discoveryBoxModal',
  }

  export enum ECartPageCoupons {
    COUPON_CODE_LIST_ITEM = 'couponCode',
    COUPON_INPUT = 'enterCouponCode',
    COUPON_SUBMIT_BUTTON = 'couponCodeOk',
    COUPON_WRAPPER = 'couponWrapper',
  }

  export enum ECartPageDiscounts {
    DISCOUNT_CODE_LIST_ITEM = 'discountCode',
  }

  export enum ECartPageBenefits {
    BENEFITS_SECTION = 'benefitsSection',
    FREE_DELIVERY_BENEFIT = 'benefitFreeDelivery',
  }

  export enum ECartPageGifts {
    GIFT_COLLAPSIBLE_SECTION = 'freeGift',
    GIFT_ACTION = 'giftAction',
  }

  export enum ECartPageProducts {
    PRODUCT_WRAPPER = 'product',
    ENGRAVING_WRAPPER = 'engraving',
    PRODUCT_NAME = 'infoProduct',
    PRODUCT_PRICE = 'productPrice',
    PRODUCT_QUANTITY = 'quantity',
    PRODUCT_REMOVE_BUTTON = 'remove',
  }

  export enum ECartPagePrice {
    TOTAL_PRICE = 'totalPrice',
  }

  export enum ECartPageModals {
    WARNING_MODAL = 'warningModal',
  }

  export enum EGiftPackaging {
    BOX = 'giftBox',
    COLOR_PICKER = 'boxSelection',
    CARD_CHECKBOX = 'cardMessage',
    ADD_BOX_BUTTON = 'addBox',
    REMOVE_BOX_BUTTON = 'removeBox',
    SAVE_GIFT_PACKAGING_BUTTON = 'saveBox',
    BOX_IS_FULL = 'boxIsFull',
    ITEM_OVER_SIZED = 'itemOverSized',
  }

  export enum EReservationPageCoupons {
    COUPON_CODE_LIST_ITEM = 'couponCode',
    COUPON_INPUT = 'enterCouponCode',
    COUPON_SUBMIT_BUTTON = 'couponCodeOk',
  }

  export enum EReservationPageProducts {
    PRODUCT_WRAPPER = 'product',
    PRODUCT_NAME = 'infoProduct',
    PRODUCT_PRICE = 'productPrice',
    PRODUCT_QUANTITY = 'quantity',
    PRODUCT_REMOVE_BUTTON = 'remove',
  }

  export enum EReservationPagePrice {
    TOTAL_PRICE = 'totalPrice',
  }

  export enum EUpsellingPage {
    BUTTON_PREVIOUS = 'buttonPrevious',
    BUTTON_NEXT = 'buttonNext',
    PRODUCT_WRAPPER = 'productList',
    PRODUCT = 'product',
    BUTTON_REMOVE_FROM_CART = 'buttonRemoveFromCart',
    BUTTON_BUY = 'buttonBuy',
  }

  export enum EFreeDeliveryProgressBar {
    FREE_DELIVERY_WRAPPER = 'freeDeliveryWrapper',
    FREE_DELIVERY_PROGRESS_BAR = 'freeDeliveryProgressBar',
  }

  export enum ESummaryPage {
    ORDER_SUMMARY_ENGRAVING = 'orderSummaryEngraving',
    ORDER_SUMMARY_SERVICE = 'orderSummaryService',
  }
}
